import * as R from 'ramda'
import React from 'react'

// import * as NmiForm from './NmiForm'
import { DonateNow } from './DonateNow'
import ModalWithPaymentForm from '@newswebsiteapp/shared/react/ModalWithPaymentForm'
// import { generateErrorMessage, calculatedonateNows } from './utils/donateNows'
import collectJs_handleResponse_implementation from '@newswebsiteapp/shared/react/utils/collectJs_handleResponse_implementation'
import { useNmiFormRecaptchaModal, useNmiFormRecaptchaModal_onSubmitPrepare } from '@newswebsiteapp/shared/react/utils/useNmiFormRecaptchaModal'

export default function App({ recaptchaSiteKey, recaptchaSiteKey_disabled, dataFromServer, modalFields_note_show, url, selectedNonDefaultDonationRecipient_id }) {
  const lastValidDataRef_donateNow = React.useRef(null)

  // console.log('render:', donateNowForm_state)

  const {
    lastValidDataRef_formData,
    lastValidDataRef_recaptchaToken,
    recaptchaInstanceRef,
    modalOpen,
    setModalOpen,
    recaptchaToken,
    setRecaptchaToken,
    submittingFinalForm,
    setSubmittingFinalForm,
    formError,
    setFormError,
    control,
    handleSubmit,
    collectJS,
    collectJs_handleTimeout,
  } = useNmiFormRecaptchaModal({ dataFromServer })

  // console.log({ recaptchaToken, submittingFinalForm })

  // React.useEffect((orderDetails) => {
  //   console.log('useEffect!!!!')
  //   donateNowForm_handledonateNowQuantity({ donateNowId: dataFromServer.conference_donateNows[1].id, newQuantity: 2, donateNowForm_updateState, dataFromServer })
  //   donateNowForm_handlePurchaseNow({ donateNowForm_updateState, dataFromServer })
  //   console.log('useEffect end!!!!')
  // }, [])

  // onFieldInvalid: fieldName => console.log('onFieldInvalid: ', fieldName),
  // on error - onTimeout will be called

  const donateNow_handleSuccess = React.useCallback((formData) => {
    console.log('donateNow_handleSuccess: ', formData)
    lastValidDataRef_donateNow.current = formData
    setModalOpen(true)
  })

  const collectJs_handleResponse = React.useCallback((response) => {
    const donateNow = lastValidDataRef_donateNow.current
    if (!donateNow) {
      throw new Error('donateNow is empty, possible, TODO use setTimeout?')
    }

    collectJs_handleResponse_implementation({
      url,
      response,
      lastValidDataRef_formData,
      lastValidDataRef_recaptchaToken,
      submittingFinalForm,
      /// ///
      setFormError,
      setSubmittingFinalForm,
      collectJS,
      recaptchaInstanceRef,
      setRecaptchaToken,
      recaptchaSiteKey_disabled,
      otherBodyData: donateNow,
      onSuccess: () => setModalOpen(false),
      onError: () => {
      },
    })
  }, [collectJS, url])

  const onSubmit = React.useCallback(
    (formData) => {
      useNmiFormRecaptchaModal_onSubmitPrepare({
        collectJS,
        setFormError,
        submittingFinalForm,
        setSubmittingFinalForm,
        recaptchaSiteKey_disabled,
        lastValidDataRef_formData,
        lastValidDataRef_recaptchaToken,
        recaptchaToken,
        formData,
        callback: () => {
          // console.log('collectJS', collectJS)
          collectJS.startPaymentRequest()
          // NOTE: will continue in onResponse !!!
        },
      })
    },
    [collectJS, submittingFinalForm, recaptchaToken],
  )

  /// /////////////////////////////////////////////////////////////////

  /// /////////////////////////////////////////////////////////////////

  return (
    <>
      <DonateNow
        dataFromServer={dataFromServer}
        setModalOpen={setModalOpen}
        onSuccess={donateNow_handleSuccess}
        selectedNonDefaultDonationRecipient_id={selectedNonDefaultDonationRecipient_id}
      />

      <ModalWithPaymentForm
        modalOpen={modalOpen}
        recaptchaSiteKey={recaptchaSiteKey}
        recaptchaSiteKey_disabled={recaptchaSiteKey_disabled}
        handleReaptchaSuccess={setRecaptchaToken}
        handleReaptchaErrorOrExpire={() => { lastValidDataRef_recaptchaToken.current = null; setRecaptchaToken(null) }}
        handleModalClose={() => setModalOpen(false)}
        control={control}
        submittingFinalForm={submittingFinalForm}
        formError={formError}
        onSubmit={handleSubmit(onSubmit)}
        collectJs_handleTimeout={collectJs_handleTimeout}
        collectJs_handleResponse={collectJs_handleResponse}
        modalFields_email_disabled={!!R.path(['current_user', 'email'], dataFromServer)}
        setRecaptchaInstance={instance => { recaptchaInstanceRef.current = instance }}
        modalFields_note_show={modalFields_note_show}
        required_address_fields={dataFromServer.required_address_fields}
      />
    </>
  )
}
